/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const organizationList=usersList.injectEndpoints({
    tagTypes:['Org','OrgHistory','OrgHistoryExport'],
    endpoints:(builder)=>({
        getOrganizations: builder.query({
            query: (searchParams) => `organizations?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Org',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Org', id:_id}))
            ]:[]

            
        }),
        getOrganization:builder.query({
            query:(id)=>`/organizations/${id}`,
            
            providesTags: (result, error, arg) => [{ type: 'Org', id: arg }],
            invalidatesTags:['OrgHistory'],
        
        }),
        addOrganization:builder.mutation({
            query:({body,id})=>({
                url:id===undefined?`organizations`:`organizations/add-subdivision/${id}`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['Org','OrgHistory']
        }),
        exportOrganizations:builder.mutation({
            query:({columns,dateformat,params})=>{
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url:`organizations/export-organization-list?${queryParams}`,
                    method:'POST',
                    body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
                };
            },
        }),
        getOrganizationActivityHistory: builder.query({
            query: (searchParams) => `organizations/list-changes?${searchParams}`,
            providesTags: ['OrgHistory'],
        }),      
        editOrganization:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/organizations/${id}`:`/organizations/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Org', id: arg.id },'OrgHistory']
        }),
        editOrganizationSubDiv:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/organizations/update-subdivision/${id}`:`/organizations/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Org', id: arg.id },'OrgHistory']
        }),
        // exportOrgUsersActivity:builder.mutation({
        //     query:({queryString,columns,dateformat})=>({
        //         url:`organizations/export-profile-changes?${queryString}`,
        //         method:'POST',
        //         body:{"columns":columns,"dateformat":dateformat}
        //     }),
        // }),
        exportOrgUsersActivity:builder.mutation({
            query:({columns,dateformat,queryString})=>({
                url:`organizations/export-profile-changes?${queryString}`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
            invalidatesTags:['OrgHistoryExport']
        }),
        getOrgViewExportHistory: builder.query({
            query: (searchParams) => `organizations/list-profile-exports?${searchParams}`,
            providesTags: ['OrgHistoryExport']
        }), 
        exportOrgExportLog:builder.mutation({
            query:({columns,dateformat,organization_id})=>({
                url:`organizations/export-export-history`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"target_organization":organization_id,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
        }),
        getOrgMonitorList: builder.query({
            query: (searchParams) => `organizations/list-users?${searchParams}`,
            

            
        }),
        getOrgPatientList: builder.query({
            query: (searchParams) => `organizations/list-patients?${searchParams}`,
            

            
        }),
        exportOrgViewMonitorList:builder.mutation({
            query:({queryString,columns})=>({
                url:`organizations/export-users/${queryString}`,
                method:'POST',
                body:{"columns":columns}
            }),
            invalidatesTags:['OrgHistoryExport']
        }),
        exportOrgViewPatientList:builder.mutation({
            query:({queryString,columns})=>({
                url:`organizations/export-patient/${queryString}`,
                method:'POST',
                body:{"columns":columns}
            }),
            invalidatesTags:['OrgHistoryExport']
        }),
        getOrgProviderList: builder.query({
            query: (searchParams) => `organizations/list-patients?${searchParams}`,  
        }),
        exportOrgViewProviderList:builder.mutation({
            query:({queryString,columns})=>({
                url:`organizations/export-users/${queryString}`,
                method:'POST',
                body:{"columns":columns}
            }),
            invalidatesTags:['OrgHistoryExport']
        }),

    }),
    
    overrideExisting: false
})


export const {useLazyGetOrgPatientListQuery,useGetOrganizationsQuery,useAddOrganizationMutation,useGetOrganizationQuery,useLazyGetOrganizationQuery ,useExportOrganizationsMutation,useEditOrganizationMutation,useGetOrganizationActivityHistoryQuery,useEditOrganizationSubDivMutation,useExportOrgUsersActivityMutation,useGetOrgViewExportHistoryQuery,useExportOrgExportLogMutation,useLazyGetOrgMonitorListQuery,useExportOrgViewMonitorListMutation,useExportOrgViewPatientListMutation,useExportOrgViewProviderListMutation}=organizationList